import { useRouter } from "next/navigation";
import Skeleton from "react-loading-skeleton";
import type { Location } from "~/types";
import { Box } from "../Box/Box";
import { Text } from "../Text/Text";
import { TextButton } from "../TextButton/TextButton";
export function LocationPanel({
  loc,
  canChangeLocation,
  skeleton,
}: {
  loc?: Location;
  canChangeLocation: boolean;
  skeleton: boolean;
}) {
  const router = useRouter();

  return (
    <>
      <Box width="full" display="flex" alignItems={"flexEnd"}>
        <Text weight="semi-strong" size="xxlarge" font="accent">
          {skeleton ? <Skeleton width={200} /> : loc?.address?.locality}
        </Text>
        {!skeleton && canChangeLocation && (
          <Box style={{ marginLeft: "auto" }}>
            <TextButton onClick={() => router.push("/select-location")}>
              Change Store
            </TextButton>
          </Box>
        )}
      </Box>
      <Text
        color="neutral-600"
        font="special"
        weight="semi-strong"
        size="large"
      >
        {skeleton ? <Skeleton width={80} /> : loc?.address?.street}
      </Text>
      <Text
        color="neutral-600"
        font="special"
        weight="semi-strong"
        size="large"
      >
        {skeleton ? <Skeleton width={160} /> : <>Phone: {loc?.phoneNumber}</>}
      </Text>
    </>
  );
}
